import { createStore, applyMiddleware } from 'redux'
import thunk from 'redux-thunk'
import promiseMiddleware from 'redux-promise-middleware'
import { rootReducer } from './rootReducer'

const createStoreWithMiddleware = applyMiddleware(thunk, promiseMiddleware())(createStore)

export const initStore = () => {
  return createStoreWithMiddleware(rootReducer, window.devToolsExtension && window.devToolsExtension())
}
